import { Source, Layer } from 'react-map-gl';
import { COLOR } from '../styles';
import { sourceProps } from './source-utils';

export function AsentamientosLayer({ url }: { url: string }) {
  return (
    <Source id="asentamientos" {...sourceProps(url)}>
      <Layer
        id="asentamientos-fill"
        type="fill"
        paint={{ 'fill-color': COLOR.coral, 'fill-opacity': 0.13 }}
      />
      <Layer
        id="asentamientos-casing"
        type="line"
        paint={{ 'line-color': 'rgba(0,0,0,0.50)', 'line-width': 4, 'line-opacity': 0.55 }}
      />
      <Layer
        id="asentamientos-outline"
        type="line"
        paint={{ 'line-color': COLOR.coral, 'line-width': 1.8, 'line-opacity': 0.90, 'line-dasharray': [8, 4] }}
      />
    </Source>
  );
}
